import { render, staticRenderFns } from "./usingHelp.vue?vue&type=template&id=bc3d9e20&"
import script from "./usingHelp.vue?vue&type=script&lang=js&"
export * from "./usingHelp.vue?vue&type=script&lang=js&"
import style0 from "./usingHelp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports